import * as React from 'react';
import cx from 'classnames';
import { useStaticQuery, graphql } from 'gatsby';

import { Clickable } from '../../../../components/Clickable/Clickable';
import { routes } from '../../../../config/routes';

import * as cs from './UpcomingEvent.module.css';

interface Props {
  whiteBg?: boolean;
  show?: boolean;
}

export const UpcomingEvent = ({ whiteBg, show }: Props) => {
  const data = useStaticQuery(graphql`
    query UpcomingEventStaticQuery {
      allEvent(
        filter: { event: { upcoming: { eq: true } }, type: { eq: "talk" } }
        sort: { event: { date_start: ASC } }
      ) {
        edges {
          node {
            slug
            event {
              dateStartMonth: date_start(formatString: "MMMM")
              dateStartDay: date_start(formatString: "D")
              dateEndMonth: date_end(formatString: "MMMM")
              dateEndDay: date_end(formatString: "D")
              upcoming
              title
              city
            }
          }
        }
      }
    }
  `);

  const events = data.allEvent.edges.filter(
    (edge: any) => edge.node.event.upcoming,
  );

  if (!show || !events || events.length < 1) {
    return null;
  }

  const {
    slug,
    event: {
      dateStartMonth,
      dateStartDay,
      dateEndMonth,
      dateEndDay,
      title,
      city,
    },
  } = events[0].node;

  const hasDateEnd = dateEndDay && dateEndDay !== dateStartDay;
  const small = hasDateEnd && (dateStartDay > 9 || dateEndDay > 9);

  return (
    <Clickable
      to={routes.event(slug)}
      className={cx(cs.wrapper, { [cs.whiteBg]: whiteBg })}
      trackEvent="primary-navigation-upcoming-event"
      trackLabel={slug}
    >
      <div className={cs.dateWrapper}>
        <div className={cx(cs.day, { [cs.small]: small })}>
          {dateStartDay}
          {hasDateEnd && '-'}
        </div>

        <div className={cs.month}>{dateStartMonth.slice(0, 3)}</div>
      </div>

      {hasDateEnd && (
        <div className={cs.dateWrapper}>
          <div className={cx(cs.day, { [cs.small]: small })}>{dateEndDay}</div>
          {dateStartMonth !== dateEndMonth && (
            <div className={cx(cs.month)}>{dateEndMonth.slice(0, 3)}</div>
          )}
        </div>
      )}

      <div className={cs.text}>{`Meet us${title ? ' at ' + title : ''}${
        city ? ' in ' + city : ''
      }!`}</div>
    </Clickable>
  );
};
